import { render, staticRenderFns } from "./PDMOverview.vue?vue&type=template&id=aa4818e2&scoped=true&lang=pug"
import script from "./PDMOverview.vue?vue&type=script&lang=js"
export * from "./PDMOverview.vue?vue&type=script&lang=js"
import style0 from "./PDMOverview.vue?vue&type=style&index=0&id=aa4818e2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4818e2",
  null
  
)

export default component.exports